import React, { PureComponent } from 'react';
import {
  List,
  ListSubheader,
  TextField,
  InputAdornment,
  IconButton,
  Icon,
} from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import ContactListItem from './ContactListItem';

class ContactsList extends PureComponent {
  state = {
    searchString: '',
  };

  handleSearchChange = event => {
    this.setState({ searchString: event.target.value });
  };

  handleSearchClear = () => {
    this.setState({ searchString: '' });
  };

  render() {
    const {
      classes,
      contacts,
      disableCall,
      selectedContact,
      withSearch,
      onContactSelect,
      onContactDelete,
    } = this.props;
    const { searchString } = this.state;

    const filteredContacts = contacts.filter(contact => {
      if (!searchString) return true;
      const ucSearchString = searchString.toUpperCase();
      return (
        contact.name?.toUpperCase().includes(ucSearchString) ||
        contact.position?.toUpperCase().includes(ucSearchString) ||
        contact.phone?.includes(ucSearchString)
      );
    });

    return (
      <>
        <List disablePadding>
          {withSearch && (
            <ListSubheader className={classes.searchContainer}>
              <TextField
                variant="standard"
                value={searchString}
                fullWidth
                placeholder="Search"
                InputProps={
                  searchString
                    ? {
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={this.handleSearchClear}
                              size="large"
                            >
                              <Icon>cancel</Icon>
                            </IconButton>
                          </InputAdornment>
                        ),
                      }
                    : null
                }
                onChange={this.handleSearchChange}
              />
            </ListSubheader>
          )}
          {filteredContacts.map(item => (
            <ContactListItem
              key={item._id}
              contact={item}
              disableCall={disableCall}
              onClick={onContactSelect}
              onDelete={onContactDelete}
              selected={selectedContact && selectedContact._id === item._id}
            />
          ))}
        </List>
      </>
    );
  }
}

ContactsList.defaultProps = {
  contacts: [],
};

const styles = theme => ({
  searchContainer: {
    background: theme.palette.common.white,
  },
});

export default withStyles(styles)(ContactsList);
